<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-cogs"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('style_guide') }}
        </div>
      </template>
      <v-row class="mx-0">
        <v-col cols="12">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>Logo (Med tekst)</v-expansion-panel-header>
              <v-expansion-panel-content>
                <svg
                  id="logo_full"
                  :style="'width:' + logo_full.width+'; max-width: 100%'"
                  preserveAspectRatio
                  viewBox="0 0 206 36.005"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g transform="translate(.026)">
                    <path
                      transform="translate(-5.487 -3.481)"
                      d="M50.614,21.484h0V34.546a3.752,3.752,0,0,1-3.768,3.768H33.7v1.172H46.762a4.949,4.949,0,0,0,4.94-4.94V21.4H50.614Z"
                      :fill="logo_full.color"
                      data-name="Path 1"
                    />
                    <g
                      transform="translate(10.211)"
                      data-name="Group 1"
                    >
                      <path
                        transform="translate(-12.2)"
                        d="M21.494,2.261A17.993,17.993,0,0,0,30.2,36H43.264a4.949,4.949,0,0,0,4.94-4.94V18A17.9,17.9,0,0,0,30.286,0a18.3,18.3,0,0,0-8.792,2.261ZM47.116,18V31.064a3.752,3.752,0,0,1-3.768,3.768H30.286A16.828,16.828,0,0,1,22.164,3.266a17.24,17.24,0,0,1,8.122-2.093A16.831,16.831,0,0,1,47.116,18Zm0,0"
                        :fill="logo_full.color"
                        data-name="Path 2"
                      />
                    </g>
                    <path
                      transform="translate(-2.005)"
                      d="M48.3,26.71V18a18.028,18.028,0,0,0-18-18h-.921a17.871,17.871,0,0,0-7.787,2.261h0c-.5.251-.921.586-1.423.837A18.018,18.018,0,0,0,30.3,36h8.541l-.251-1.172H30.3A16.828,16.828,0,0,1,22.18,3.266,17.24,17.24,0,0,1,30.3,1.172,16.831,16.831,0,0,1,47.132,18h0v8.457m0-8.457"
                      :fill="logo_full.color"
                      data-name="Path 3"
                    />
                    <path
                      d="M25.7,1l-2.512.5-3.182,1L16.072,5.861H1.5c-.167,0-.251-.084-.335-.335L0,.837C-.088.419.079,0,.331,0H28.213Z"
                      :fill="logo_full.color"
                      data-name="Path 4"
                    />
                    <path
                      transform="translate(-.342 -1.367)"
                      d="M12.143,14.261H3.6c-.167,0-.251-.167-.335-.419L2.1,9.237c-.084-.419.084-.837.335-.837H14.99"
                      :fill="logo_full.color"
                      data-name="Path 5"
                    />
                    <path
                      transform="translate(-.683 -2.733)"
                      d="M11.062,22.745H5.7c-.167,0-.251-.167-.335-.419L4.2,17.637c-.084-.419.084-.837.335-.837h7.7"
                      :fill="logo_full.color"
                      data-name="Path 6"
                    />
                    <path
                      transform="translate(-2.867 -.862)"
                      d="m31.164 32.429a13.565 13.565 0 1 0-13.564-13.564 13.561 13.561 0 0 0 13.564 13.564zm8.625-9.629a9.469 9.469 0 1 1-8.625-13.4 9.357 9.357 0 0 1 8.536 5.445h-3.847a6.21 6.21 0 1 0-4.689 10.3 6.527 6.527 0 0 0 4.856-2.261h3.768v-0.084z"
                      :fill="logo_full.color"
                      fill-rule="evenodd"
                      data-name="Path 7"
                    />
                    <g
                      transform="translate(53.835 8.373)"
                      :fill="logo_full.color"
                      data-name="Group 2"
                    >
                      <path
                        transform="translate(-64.3 -10)"
                        d="m64.3 21.639a11.335 11.335 0 0 1 11.555-11.639c4.856 0 7.62 2.6 8.792 5.61l-4.1 1.34a5.018 5.018 0 0 0-4.94-3.266c-3.768 0-6.95 3.266-6.95 7.62a5.276 5.276 0 0 0 5.61 5.443 6.6 6.6 0 0 0 4.689-2.261l3.266 2.177a10.226 10.226 0 0 1-8.122 3.851c-5.53 0-9.8-3.514-9.8-8.875z"
                        data-name="Path 8"
                      />
                      <path
                        transform="translate(-68.009 -11.057)"
                        d="m87.1 25.041a8.361 8.361 0 0 1 8.289-8.541c4.605 0 7.117 2.763 7.117 6.531a8.43 8.43 0 0 1-8.373 8.541c-4.521 0-7.033-2.763-7.033-6.531zm11.471-1.841a3.081 3.081 0 0 0-3.349-3.349c-2.6 0-4.27 2.428-4.27 5.024a3.081 3.081 0 0 0 3.348 3.347c2.6 0 4.271-2.428 4.271-5.022z"
                        data-name="Path 9"
                      />
                      <path
                        transform="translate(-71.149 -11.057)"
                        d="m106.4 25.041a8.361 8.361 0 0 1 8.289-8.541c4.605 0 7.117 2.763 7.117 6.531a8.43 8.43 0 0 1-8.373 8.541c-4.521 0-7.033-2.763-7.033-6.531zm11.555-1.841a3.081 3.081 0 0 0-3.349-3.349c-2.6 0-4.27 2.428-4.27 5.024a3.081 3.081 0 0 0 3.349 3.349c2.515-2e-3 4.27-2.43 4.27-5.024z"
                        data-name="Path 10"
                      />
                      <path
                        transform="translate(-74.191 -10.065)"
                        d="m125.1 30.244 4.354-19.844h3.768l-4.354 19.844z"
                        data-name="Path 11"
                      />
                      <path
                        transform="translate(-75.509 -10.065)"
                        d="m144.59 30.244-2.344-7.033h-3.266l-1.507 7.033h-4.27l4.354-19.844h8.457c3.182 0 6.112 2.177 6.112 5.61a6.959 6.959 0 0 1-5.694 6.95l2.763 7.368h-4.605zm-0.335-10.8c2.177 0 3.517-1.256 3.517-3.1a2.366 2.366 0 0 0-2.512-2.261h-4.27l-1.172 5.359z"
                        data-name="Path 12"
                      />
                      <path
                        transform="translate(-79.202 -11.123)"
                        d="M162.012,16.9l-1.926,8.708a2.848,2.848,0,0,0-.084.837c0,1.34,1.089,1.842,2.428,1.842a5.584,5.584,0,0,0,3.433-1.675l2.177-9.713h3.768l-3.266,14.4h-3.768l.419-1.842a6.988,6.988,0,0,1-4.773,2.261c-2.763,0-4.521-1.423-4.521-3.684a5.651,5.651,0,0,1,.168-1.172l2.177-9.88h3.768Z"
                        data-name="Path 13"
                      />
                      <path
                        transform="translate(-82.228 -11.057)"
                        d="M184.129,31.237l1.926-8.541a3.561,3.561,0,0,0,.167-.921c0-1.34-1.088-1.842-2.177-1.842a5.23,5.23,0,0,0-3.6,1.675l-2.177,9.713H174.5l3.182-14.4h3.768l-.419,1.842A6.988,6.988,0,0,1,185.8,16.5c2.763,0,4.522,1.423,4.522,3.684a5.655,5.655,0,0,1-.167,1.172l-2.177,9.88h-3.852Z"
                        data-name="Path 14"
                      />
                      <path
                        transform="translate(-85.401 -11.057)"
                        d="M203.629,31.237l1.926-8.541a3.561,3.561,0,0,0,.167-.921c0-1.34-1.089-1.842-2.177-1.842a5.23,5.23,0,0,0-3.6,1.675l-2.177,9.713H194l3.182-14.4h3.768l-.419,1.842A6.988,6.988,0,0,1,205.3,16.5c2.763,0,4.521,1.423,4.521,3.684a5.659,5.659,0,0,1-.167,1.172l-2.261,9.88Z"
                        data-name="Path 15"
                      />
                      <path
                        transform="translate(-88.671 -11.057)"
                        d="m214.1 25.124a8.384 8.384 0 0 1 8.289-8.624 6.108 6.108 0 0 1 6.447 6.447 8.729 8.729 0 0 1-0.335 2.344h-10.717v0.335c0 1.256 1.256 3.014 3.935 3.014a6.319 6.319 0 0 0 3.6-1.089l1.172 2.6a9.62 9.62 0 0 1-5.108 1.507c-4.352-0.086-7.283-2.515-7.283-6.534zm11.387-2.424v-0.335a2.953 2.953 0 0 0-3.266-2.931 4.151 4.151 0 0 0-3.935 3.182h7.2z"
                        data-name="Path 16"
                      />
                      <path
                        transform="translate(-91.599 -11.041)"
                        d="M232.1,31.221l3.182-14.4h3.768l-.419,1.842a6.664,6.664,0,0,1,5.108-2.261l-.837,3.768a4.744,4.744,0,0,0-1.34-.167,4.83,4.83,0,0,0-3.6,1.758l-2.093,9.462Z"
                        data-name="Path 17"
                      />
                    </g>
                  </g>
                </svg>
                <v-row>
                  <v-col cols="3">
                    <v-menu
                      :ref="`color_menu-logo_full`"
                      v-model="colorMenu.logo_full"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      max-width="300px"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="logo_full.color"
                          :label="$t('color')"
                          append-icon="palette"
                          readonly
                          v-on="on"
                        />
                      </template>

                      <v-color-picker
                        v-model="logo_full.color"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      :label="$t('width')"
                      :value="logo_full.width"
                      type="number"
                      @input="v => {logo_full.width = v, logo_full.height = v/5.72}"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      :label="$t('height')"
                      :value="logo_full.height"
                      type="number"
                      @input="v => {logo_full.height = v, logo_full.width = v*5.72}"
                    />
                  </v-col>
                  <v-col>
                    <v-btn
                      color="primary"
                      @click="saveLogo('logo_full')"
                    >
                      {{ $t('save') + ' PNG' }}
                    </v-btn>
                    <v-btn
                      class="ml-2"
                      color="primary"
                      @click="saveLogo('logo_full', true)"
                    >
                      {{ $t('save') + ' JPG' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Logo</v-expansion-panel-header>
              <v-expansion-panel-content>
                <svg
                  id="logo"
                  viewBox="0 0 1927.735 1500.076"
                  :style="'width:' + logo.width+'; max-width: 100%'"
                  preserveAspectRatio
                >
                  <g
                    id="Group_101"
                    data-name="Group 101"
                    transform="translate(-1560 2060)"
                  >
                    <path
                      id="Path_151"
                      data-name="Path 151"
                      d="M2737.7-2060H1575.479c-11.024,0-18.506,18.755-14.282,35.8l48.066,193.918c2.394,9.664,8.031,15.963,14.282,15.963h559.021c-.2.218-.4.434-.6.653-1.854,2.043-3.688,4.107-5.518,6.17-.774.872-1.558,1.734-2.327,2.61q-3.887,4.423-7.706,8.906c-.407.478-.805.963-1.211,1.442q-3.2,3.773-6.35,7.584c-.881,1.068-1.749,2.15-2.624,3.223q-2.41,2.956-4.8,5.928c-.985,1.233-1.956,2.476-2.934,3.715q-1.781,2.257-3.545,4.526H1647.637c-11.023,0-18.505,18.756-14.281,35.8l48.066,193.918c2.4,9.665,8.031,15.964,14.282,15.964h322.928c-.108.363-.218.724-.324,1.087q-.979,3.313-1.93,6.637-.723,2.529-1.424,5.064-.926,3.335-1.821,6.681-.68,2.535-1.344,5.078-.881,3.388-1.727,6.788c-.417,1.673-.838,3.343-1.245,5.02-.568,2.337-1.116,4.683-1.661,7.028-.376,1.613-.756,3.225-1.121,4.842-.171.758-.331,1.521-.5,2.281H1721.516c-11.024,0-18.508,18.756-14.283,35.8l48.067,193.918c2.4,9.665,8.031,15.963,14.283,15.963h222.549v-.01C2033.1-852.174,2351.261-559.923,2737.7-559.923h545.459c112.985,0,204.579-91.6,204.579-204.58v-545.459C3487.736-1724.2,3151.932-2060,2737.7-2060ZM3440-959.328V-764.5a156.848,156.848,0,0,1-156.848,156.849H2737.7c-387.874,0-702.308-314.434-702.308-702.308,0-258.2,140.491-491.678,362.255-614.649a698.859,698.859,0,0,1,340.053-87.659c387.874,0,702.307,314.434,702.307,702.308Z"
                      transform="translate(0 0)"
                      :fill="logo.color"
                    />
                    <path
                      id="Path_152"
                      data-name="Path 152"
                      d="M2545.038-802c312.56,0,565.938-253.379,565.938-565.938s-253.378-565.938-565.938-565.938S1979.1-1680.5,1979.1-1367.94,2232.48-802,2545.038-802Zm360.133-402.293c-62.238,136.753-200.082,231.829-360.133,231.829-218.414,0-395.474-177.06-395.474-395.475s177.061-395.474,395.474-395.474c157.377,0,293.282,91.925,356.953,225.011H2740.177a258.5,258.5,0,0,0-195.139-88.641c-143.1,0-259.1,116.006-259.1,259.1s116.006,259.1,259.1,259.1a258.592,258.592,0,0,0,200.9-95.458h159.236Zm0,0"
                      transform="translate(192.66 57.978)"
                      :fill="logo.color"
                    />
                  </g>
                </svg>
                <v-row>
                  <v-col cols="3">
                    <v-menu
                      :ref="`color_menu-logo`"
                      v-model="colorMenu.logo"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      max-width="300px"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="logo.color"
                          :label="$t('color')"
                          append-icon="palette"
                          readonly
                          v-on="on"
                        />
                      </template>

                      <v-color-picker
                        v-model="logo.color"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      :label="$t('width')"
                      :value="logo.width"
                      type="number"
                      @input="v => {logo.width = v, logo.height = v/1.28}"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      :label="$t('height')"
                      :value="logo.height"
                      type="number"
                      @input="v => {logo.height = v, logo.width = v*1.28}"
                    />
                  </v-col>
                  <v-col>
                    <v-btn
                      color="primary"
                      @click="saveLogo('logo')"
                    >
                      {{ $t('save') + ' PNG' }}
                    </v-btn>
                    <v-btn
                      class="ml-2"
                      color="primary"
                      @click="saveLogo('logo', true)"
                    >
                      {{ $t('save') + ' JPG' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>HomeRunner Logo (Med tekst)</v-expansion-panel-header>
              <v-expansion-panel-content>
                <svg
                  id="homerunner_logo_full"
                  :style="'width:' + homerunner_logo_full.width+'; max-width: 100%'"
                  preserveAspectRatio
                  viewBox="0 0 806.85 130.67"
                ><defs /><g
                  :fill="homerunner_logo_full.color"
                ><path
                  class="cls-1"
                  d="M243.06 73.75h-31.2l-6.14 30.15h-14.06l14.56-71.82h14.06l-5.65 28.21h31.1l5.75-28.21h14.16l-14.56 71.82h-14.16zM293.84 50.6c16.58 0 25.84 10.12 25.84 23.69 0 16.15-12.49 30.9-30.15 30.9-16.58 0-25.73-10-25.73-23.58 0-16.26 12.49-31.01 30.04-31.01zm-.43 12.17c-9.26 0-15.51 8.83-15.51 18.09 0 7.53 4.52 12.16 12.17 12.16 9.15 0 15.4-8.72 15.4-18.09 0-7.53-4.53-12.16-12.06-12.16zM393 72.46a22.21 22.21 0 00.43-3.45c0-4-3.45-6.24-7.43-6.24-4.2 0-8.19 3-10.88 6l-7.64 35.1H353.7l7-31.44a19.12 19.12 0 00.53-3.77c-.1-3.34-2.8-5.92-7.64-5.92-4.09 0-8.08 3.12-10.66 6l-7.75 35.1h-13.67l11.51-52h13.68l-1.51 6.79c2.91-3.13 8.18-8.08 15.83-8.08 10.23 0 14.32 7.43 14.32 9.37v.32c4.09-5.06 10-9.69 18-9.69s14.86 4.74 14.86 13.24a22.7 22.7 0 01-.54 4.31l-7.86 35.75H386zM441 50.6c13.24 0 23.36 8.72 23.36 23.26a33.86 33.86 0 01-1.07 8.39h-38.64v1.3c0 4.41 4.62 10.76 14.21 10.76 4.52 0 9.9-1.4 13.13-3.87l4.31 9.36a33.8 33.8 0 01-18.41 5.39c-16.37 0-26.92-8.83-26.92-23.37C411 64.92 423.68 50.6 441 50.6zm11.1 21.32c0-5.17-3.66-10.44-12-10.44-7.32 0-12.92 5.81-14.1 11.52h26.1zM499.47 78.16h-12l-5.6 25.74h-15.24l15.83-71.82h30.69c11.62 0 22.18 7.75 22.18 20.24a24.84 24.84 0 01-20.46 25l9.9 26.6h-16.9zm19.81-24.33c0-5.06-4.2-8.61-9.15-8.61h-15.29L490.54 65h15.93c8.08 0 12.81-4.71 12.81-11.17zM549.43 83.22a16.41 16.41 0 00-.43 3.13c0 4.73 3.87 6.67 8.72 6.67s9.36-3.23 12.38-6.14l7.75-35h13.67L580 103.9h-13.67l1.51-6.79c-4.09 3.88-9.69 8.08-17.34 8.08-10 0-16.25-5.28-16.25-13.35a30.72 30.72 0 01.53-4.2l7.86-35.75h13.79zM631.25 72.89a17.38 17.38 0 00.54-3.45c0-4.84-3.88-6.67-8-6.67-5.6 0-10.12 3.12-13.13 6l-7.76 35.1h-13.64l11.52-52h13.67L613 58.68c4.09-4 9.69-8.08 17.33-8.08 10 0 16.26 5.28 16.26 13.24a30.76 30.76 0 01-.54 4.31l-8 35.75h-13.69zM689.28 72.89a17.38 17.38 0 00.54-3.45c0-4.84-3.88-6.67-8-6.67-5.6 0-10.12 3.12-13.13 6L661 103.9h-13.71l11.52-52h13.67L671 58.68c4.09-4 9.69-8.08 17.33-8.08 10 0 16.26 5.28 16.26 13.24a30.76 30.76 0 01-.54 4.31l-8 35.75h-13.66zM739.56 50.6c13.24 0 23.36 8.72 23.36 23.26a33.8 33.8 0 01-1.08 8.39h-38.65v1.3c0 4.41 4.63 10.76 14.22 10.76 4.52 0 9.9-1.4 13.13-3.87l4.31 9.36a33.8 33.8 0 01-18.41 5.39c-16.37 0-26.92-8.83-26.92-23.37 0-16.9 12.7-31.22 30.04-31.22zm11.09 21.32c0-5.17-3.66-10.44-11.95-10.44-7.32 0-12.92 5.81-14.11 11.52h26.06zM776.38 51.89h13.67l-1.61 6.89a23.67 23.67 0 0118.41-8.07l-2.91 13.56a21.75 21.75 0 00-5.06-.64c-5 0-9.8 2.8-12.92 6.24l-7.43 34h-13.67z"
                /><path
                  d="M102.59 0H1.35C.39 0-.26 1.63.1 3.12L4.29 20c.21.84.7 1.39 1.25 1.39h48.69l-.83.93-.08.09-.69.81-.19.23-.57.69-.23.27c-.18.23-.36.47-.55.7l-.09.19H7.63c-1 0-1.61 1.63-1.24 3.12l4.19 16.89c.21.84.7 1.39 1.24 1.39H40q-.31 1.06-.6 2.16v.12l-.24.94c0 .09 0 .19-.07.29l-.18.79v.1H14.07c-1 0-1.61 1.63-1.24 3.12L17 71.11c.21.84.7 1.39 1.25 1.39h19.39l.09.76c0 .25.06.5.1.75a64.71 64.71 0 002.25 10.36c.07.24.14.48.22.71a64.61 64.61 0 003.27 8.29c.11.22.21.44.32.65l.31.63c.11.21.22.41.32.62l.33.62a66.13 66.13 0 003.8 6.24l.38.55v.06l.37.53.06.08.37.51.07.1c.13.16.25.33.38.5l.07.09c.12.17.25.33.38.5l.06.08.4.51v.06l.42.52c1 1.3 2.16 2.56 3.31 3.77l.06.07.42.44.1.1c.14.14.27.28.41.41l.12.13.39.39.14.14.39.38.15.14.39.38.15.14.4.37.15.13.4.37.14.13.42.37.12.11.45.39h.06c.72.62 1.45 1.23 2.2 1.82l.47.36.13.1.43.33.17.13.41.3.2.16.39.28.23.16.38.27.24.17.38.26.24.17.38.25.25.17.38.25.25.16.39.25.24.16.4.25.24.15.4.24.23.14.42.25.15.09c.52.3 1 .6 1.57.89l.24.13.39.21.28.15.38.2.3.15.37.19.31.16.37.18.32.16.36.18.33.15.37.17.33.15.36.17.34.15.36.16.35.15.36.15.35.15.36.14.36.15.35.14.38.15.34.13.44.16.43.16.57.2.31.11.42.15.34.11.39.13.35.11.4.13.35.11.39.12.35.1.4.11.35.1.4.12.36.09.4.11.35.09.41.1.35.09.42.1.35.08.42.09.34.08.45.09.33.07.48.1.29.05.66.13h.11l.78.13h.27l.51.09h.32l.47.07h.34l.45.06h.35l.44.05h.36l.44.05H150.1a17.82 17.82 0 0017.82-17.82V65.33A65.33 65.33 0 00102.59 0m61.17 65.33v47.52a13.67 13.67 0 01-13.66 13.66h-47.51a61.18 61.18 0 1161.17-61.18z"
                  fill-rule="evenodd"
                /><path
                  class="cls-1"
                  d="M102.59 16a49.3 49.3 0 1049.29 49.29A49.29 49.29 0 00102.59 16zm22.34 78.7h-10.74V71.34H90.55V94.7H79.89V39.07h10.66v21.85h23.64V39.07h10.74z"
                /></g></svg>

                <v-row>
                  <v-col cols="3">
                    <v-menu
                      :ref="`color_menu-homerunner_logo_full`"
                      v-model="colorMenu.homerunner_logo_full"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      max-width="300px"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="homerunner_logo_full.color"
                          :label="$t('color')"
                          append-icon="palette"
                          readonly
                          v-on="on"
                        />
                      </template>

                      <v-color-picker
                        v-model="homerunner_logo_full.color"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      :label="$t('width')"
                      :value="homerunner_logo_full.width"
                      type="number"
                      @input="v => {homerunner_logo_full.width = v, homerunner_logo_full.height = v/6.23}"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      :label="$t('height')"
                      :value="homerunner_logo_full.height"
                      type="number"
                      @input="v => {homerunner_logo_full.height = v, homerunner_logo_full.width = v*6.23}"
                    />
                  </v-col>
                  <v-col>
                    <v-btn
                      color="primary"
                      @click="saveLogo('homerunner_logo_full')"
                    >
                      {{ $t('save') + ' PNG' }}
                    </v-btn>
                    <v-btn
                      class="ml-2"
                      color="primary"
                      @click="saveLogo('homerunner_logo_full', true)"
                    >
                      {{ $t('save') + ' JPG' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>HomeRunner Logo</v-expansion-panel-header>
              <v-expansion-panel-content>
                <svg
                  id="homerunner_logo"
                  :style="'width:' + homerunner_logo.width+'; max-width: 100%'"
                  preserveAspectRatio
                  viewBox="0 0 169 131"
                ><g
                  id="Layer_2"
                  :fill="homerunner_logo.color"
                ><path
                  id="Layer"
                  fill-rule="evenodd"

                  class="shp0"
                  d="M102.59 0c8.58 0 17.07 1.69 25 4.97 7.93 3.29 15.13 8.1 21.2 14.16 6.06 6.07 10.87 13.27 14.16 21.2 3.28 7.93 4.97 16.42 4.97 25v46.65c0 2.34-.46 4.66-1.36 6.82-.89 2.16-2.2 4.13-3.86 5.78-1.65 1.66-3.62 2.97-5.78 3.86-2.16.9-4.48 1.36-6.82 1.36H95.55l-.44-.05h-.36l-.44-.05h-.35l-.45-.06h-.34l-.47-.07h-.32l-.51-.09h-.27l-.78-.13h-.11l-.66-.13-.29-.05-.48-.1-.33-.07-.45-.09-.34-.08-.42-.09-.35-.08-.42-.1-.35-.09-.41-.1-.35-.09-.4-.11-.36-.09-.4-.12-.35-.1-.4-.11-.35-.1-.39-.12-.35-.11-.4-.13-.35-.11-.39-.13-.34-.11-.42-.15-.31-.11-.57-.2-.43-.16-.44-.16-.34-.13-.38-.15-.35-.14-.36-.15-.36-.14-.35-.15-.36-.15-.35-.15-.36-.16-.34-.15-.36-.17-.33-.15-.37-.17-.33-.15-.68-.34-.37-.18-.31-.16-.37-.19-.3-.15-.38-.2-.28-.15-.39-.21-.24-.13c-.57-.29-1.05-.59-1.57-.89l-.15-.09-.42-.25-.23-.14-.4-.24-.64-.4-.24-.16-.39-.25-.25-.16-.38-.25-.25-.17-.38-.25-.24-.17-.38-.26-.24-.17-.38-.27-.23-.16-.39-.28-.2-.16-.41-.3-.17-.13-.43-.33-.13-.1-.47-.36c-.75-.59-1.48-1.2-2.2-1.82h-.06l-.45-.39-.12-.11-.42-.37-.14-.13-.4-.37-.15-.13-.4-.37-.15-.14-.39-.38-.15-.14-.39-.38-.53-.53-.12-.13c-.14-.13-.27-.27-.41-.41l-.1-.1-.42-.44-.06-.07c-1.15-1.21-2.31-2.47-3.31-3.77l-.42-.52v-.06l-.4-.51-.06-.08c-.13-.17-.26-.33-.38-.5l-.07-.09c-.13-.17-.25-.34-.38-.5l-.07-.1-.37-.51-.06-.08-.37-.53v-.06l-.38-.55c-.35-.5-.68-1.01-1.01-1.52-.34-.51-.66-1.03-.98-1.55-.31-.52-.62-1.04-.93-1.57-.3-.53-.59-1.06-.88-1.6l-.33-.62c-.1-.21-.21-.41-.32-.62l-.31-.63c-.11-.21-.21-.43-.32-.65-.32-.67-.63-1.35-.92-2.03-.3-.68-.59-1.37-.86-2.06s-.53-1.39-.78-2.09-.49-1.4-.71-2.11c-.08-.23-.15-.47-.22-.71-.26-.85-.5-1.7-.72-2.55-.22-.86-.43-1.72-.62-2.58-.19-.87-.36-1.74-.51-2.61-.15-.87-.28-1.74-.4-2.62-.04-.25-.1-.5-.1-.75l-.09-.76H18.25c-.55 0-1.04-.55-1.25-1.39l-4.17-16.89c-.37-1.49.24-3.12 1.24-3.12h24.84V51l.18-.79c.07-.1.07-.2.07-.29l.24-.94v-.12c.19-.73.39-1.45.6-2.16H11.82c-.54 0-1.03-.55-1.24-1.39L6.39 28.42c-.37-1.49.24-3.12 1.24-3.12H51l.09-.19c.19-.23.37-.47.55-.7l.23-.27.76-.92.69-.81.08-.09.83-.93H5.54c-.55 0-1.04-.55-1.25-1.39L.1 3.12C-.26 1.63.39 0 1.35 0h101.24zm61.17 65.33c0-24.75-14.91-47.05-37.77-56.52-22.86-9.47-49.18-4.24-66.67 13.26-17.5 17.5-22.73 43.82-13.26 66.68 9.47 22.86 31.78 37.76 56.53 37.76h47.51c1.79 0 3.57-.36 5.23-1.04 1.65-.69 3.16-1.7 4.43-2.96 1.26-1.27 2.27-2.78 2.96-4.43.68-1.66 1.04-3.44 1.04-5.23V65.33z"
                /><path
                  id="Layer"
                  fill-rule="evenodd"

                  class="shp0"
                  d="M102.59 16c6.47 0 12.88 1.27 18.86 3.75 5.98 2.48 11.42 6.11 15.99 10.69 4.58 4.57 8.21 10.01 10.69 15.99 2.48 5.98 3.75 12.39 3.75 18.86 0 19.94-12.01 37.92-30.43 45.56-18.42 7.63-39.63 3.41-53.73-10.69-14.1-14.1-18.32-35.31-10.69-53.73C64.67 28.01 82.65 16 102.59 16zm22.34 23.07h-10.74v21.85H90.55V39.07H79.89V94.7h10.66V71.34h23.64V94.7h10.74V39.07z"
                /></g></svg>

                <v-row>
                  <v-col cols="3">
                    <v-menu
                      :ref="`color_menu-homerunner_logo`"
                      v-model="colorMenu.homerunner_logo"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      max-width="300px"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="homerunner_logo.color"
                          :label="$t('color')"
                          append-icon="palette"
                          readonly
                          v-on="on"
                        />
                      </template>

                      <v-color-picker
                        v-model="homerunner_logo.color"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      :label="$t('width')"
                      :value="homerunner_logo.width"
                      type="number"
                      @input="v => {homerunner_logo.width = v, homerunner_logo.height = v/1.28}"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      :label="$t('height')"
                      :value="homerunner_logo.height"
                      type="number"
                      @input="v => {homerunner_logo.height = v, homerunner_logo.width = v*1.28}"
                    />
                  </v-col>
                  <v-col>
                    <v-btn
                      color="primary"
                      @click="saveLogo('homerunner_logo')"
                    >
                      {{ $t('save') + ' PNG' }}
                    </v-btn>
                    <v-btn
                      class="ml-2"
                      color="primary"
                      @click="saveLogo('homerunner_logo', true)"
                    >
                      {{ $t('save') + ' JPG' }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import { saveSvgAsPng } from 'save-svg-as-png'
  import { SUPPORT } from '../../../../utils/constants'

  export default {
    data () {
      return {
        crudl: {
          C: SUPPORT.val,
          R: SUPPORT.val,
          U: SUPPORT.val,
          D: SUPPORT.val,
          L: SUPPORT.val,
        },
        colorMenu: {
          logo_full: false,
          logo: false,
          homerunner_logo_full: false,
          homerunner_logo: false,
        },
        logo_full: {
          org_width: 206,
          org_height: 36.005,
          width: 206,
          height: 36.005,
          color: '#157efb',
        },
        logo: {
          org_width: 128,
          org_height: 100,
          width: 206,
          height: 36.005,
          color: '#157efb',
        },
        homerunner_logo_full: {
          org_width: 206,
          org_height: 36.005,
          width: 206,
          height: 36.005,
          color: '#157efb',
        },
        homerunner_logo: {
          org_width: 128,
          org_height: 100,
          width: 206,
          height: 36.005,
          color: '#157efb',
        },
      }
    },
    mounted: function () {

    },
    methods: {
      saveLogo: function (name, jpeg) {
        saveSvgAsPng(document.getElementById(name), `${name}.${jpeg ? 'jpg' : 'png'}`, { scale: this[name].width / this[name].org_width, encoderOptions: 1, encoderType: `image/${jpeg ? 'jpeg' : 'png'}` })
      },
    },
  }
</script>
